<template lang="pug">
  div.home
    h1 {{ message }}
    div(v-if="mmp")
      p You reserved this MMP product:
      p Name: {{ mmp.name }}
      p Price: {{ mmp.price }}
      p Deductible: {{ mmp.deductible }}
      p Months: {{ mmp.months }}
      p Miles: {{ mmp.miles }}
      p Token: {{ reservation.token }}
      p Signature: {{ reservation.signature }}
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'Confirmation',
    computed: {
      ...mapGetters(['reservation']),
      message () {
        return this.booking ? 'All booked!' : 'Please reserve something on another page, then book on Reservation.'
      },
      mmp () {
        return this.reservation && this.reservation.products && this.reservation.products.mmp
      }
    }
  }
</script>
